module.exports = __webpack_public_path__ + "static/media/apng_zilant.f7c69546.png";